import { render, staticRenderFns } from "./ProductLabelEditExpire.vue?vue&type=template&id=5fdfed74&scoped=true&"
import script from "./ProductLabelEditExpire.vue?vue&type=script&lang=js&"
export * from "./ProductLabelEditExpire.vue?vue&type=script&lang=js&"
import style0 from "./ProductLabelEditExpire.vue?vue&type=style&index=0&id=5fdfed74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdfed74",
  null
  
)

export default component.exports